import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'

import { RouteKeys, ROUTES, TmsUserPagePermissions } from '@constants'

import { LinkSpan, StyledNavLink } from '../styles'

const PartnersNavLinkMessage = <FormattedMessage id="navLink.partners" defaultMessage="Partnerek" />

interface PartnersNavLinksProps {
  blockedByOnboarding: boolean
  hasSubscription: boolean
  lastVisitedSubPage?: string
}

function PurePartnersNavLinks({ blockedByOnboarding, hasSubscription, lastVisitedSubPage }: PartnersNavLinksProps) {
  return (
    <StyledNavLink
      blockedByOnboarding={blockedByOnboarding}
      to={lastVisitedSubPage ?? ROUTES[RouteKeys.PARTNER_LIST].replace(':partner_type', 'providers')}
      permission={TmsUserPagePermissions.denyPartnerPermission}
      noSubscription={!hasSubscription}
    >
      <LinkSpan>{PartnersNavLinkMessage}</LinkSpan>
    </StyledNavLink>
  )
}

export const PartnersNavLinks = connect((state: Store) => ({
  lastVisitedSubPage: state.controls.lastVisitedSubPage[RouteKeys.PARTNER_LIST],
}))(PurePartnersNavLinks)

PartnersNavLinks.displayName = 'PartnersNavLinks'
